import { H1 } from '@/common/ui/h1'
import { APPLICATION_COPY } from '@/locales/en'
import { Check } from 'lucide-react'

export const ApplicationProgressBar = ({ active }: { active: 1 | 2 }) => {
    // Helper to get color class
    const getLineColor = (step: number) => (active > step ? 'bg-brand' : 'bg-brand-dust')

    const completedElement = (
        <div className="w-6 h-6 relative">
            <div className="w-6 h-6 left-0 top-0 absolute bg-brand rounded-full" />
            <div className="w-3 h-3 left-[6px] top-[6px] absolute overflow-hidden">
                <Check strokeWidth={3} className="w-3 h-3 text-forest" />
            </div>
        </div>
    )
    const activeElement = (
        <div className="p-1 rounded-[100px] outline outline-2 outline-offset-[-2px] outline-brand flex justify-start items-center gap-2.5">
            <div className="w-4 h-4 bg-brand rounded-full" />
        </div>
    )
    const futureElement = (
        <div className="p-1 rounded-[100px] flex justify-start items-center gap-2.5">
            <div className="w-6 h-6 bg-brand-dust rounded-full" />
        </div>
    )

    return (
        <div className="w-full gap-6 flex flex-col justify-start items-start">
            <H1 className="justify-start mb-0">{APPLICATION_COPY.progressBar.title}</H1>
            <div className="w-full max-w-96 inline-flex justify-start items-center">
                {/* Step 1 */}
                <div className="flex-1 inline-flex flex-col justify-center items-start gap-2">
                    <div className="self-stretch inline-flex justify-start items-center gap-1">
                        {active === 1 ? activeElement : completedElement}
                        <div className={`flex-1 h-1 rounded-tl rounded-bl ${getLineColor(1)}`} />
                    </div>
                    <div className="justify-start text-black text-xs font-normal font-['Inter'] leading-tight">
                        {APPLICATION_COPY.progressBar.type}
                    </div>
                </div>
                {/* Step 2 */}
                <div className="flex-1 inline-flex flex-col justify-center items-end gap-2">
                    <div className="w-full h-6 inline-flex justify-start items-center gap-2">
                        <div className={`flex-1 h-1 rounded-tr rounded-br ${getLineColor(1)}`} />
                        {active === 2 ? activeElement : futureElement}
                    </div>
                    <div className="self-stretch min-w-24 text-right justify-start text-black text-xs font-normal font-['Inter'] leading-tight">
                        {APPLICATION_COPY.progressBar.status}
                    </div>
                </div>
            </div>
        </div>
    )
}
